import { sentenceCase } from 'change-case';
import { filter } from 'lodash';
import { useEffect, useState } from 'react';
// material
import CloseIcon from '@mui/icons-material/Close';
import {
  Button,
  Card,
  Checkbox,
  Container,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  IconButton,
  Stack,
  Table,
  TableBody,
  TableCell,
  tableCellClasses,
  TableContainer,
  TableRow,
  TextField,
  Typography
} from '@mui/material';
import { styled } from '@mui/material/styles';
import { Box } from '@mui/system';
import { MdEmail, MdTextsms } from 'react-icons/md';
import { useLocation } from 'react-router-dom';
import { RiWhatsappFill } from 'react-icons/ri';
import BrudCrumbs from '../../components/BreadCrumbs';
import PageTitle from '../../components/PageHeading';
import Page from '../../components/Page';

// components
import Label from '../../components/Label';
import Scrollbar from '../../components/Scrollbar';
import SearchNotFound from '../../components/SearchNotFound';
import { UserListHead, UserMoreMenu } from '../../components/_dashboard/user';
//
import { fDate, fDateTime2 } from '../../utils/formatTime';
// import Loader from '../Global/Loader';
import Loader from './Loader';
import { CommonApiforJourney } from '../services/RecommendationApi';
// import RecommendationToolbar from './RecommendationToolbar';
import { NOT_AVAILABLE } from './Constants';
import ApiErrorMessage from './ApiErrorMessage';
import useLoginSelector from '../../store/Slice/Login/LoginSelector';

// ----------------------------------------------------------------------

const TABLE_HEAD = [
  { id: 'id', label: 'Prospect ID', alignRight: false },
  { id: 'created', label: 'Prospect Date', alignRight: false },
  { id: 'name', label: 'Prospect Name', alignRight: false },
  { id: 'randomPhoneNumber', label: 'Mobile', alignRight: false },
  { id: 'loanType', label: 'Loan Type', alignRight: false },
  { id: 'applicantType', label: 'Employment Type', alignRight: false },
  { id: 'city', label: 'City', alignRight: false },
  { id: 'completion', label: 'Completion %', alignRight: false },
  { id: 'statusRecommendation', label: 'Status', alignRight: false },
  { id: 'modifiedOn', label: 'Last Update On', alignRight: false },
  { id: 'action', label: 'ACTION' }
];

// ----------------------------------------------------------------------

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function applySortFilter(array, comparator, query) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  if (query) {
    return filter(array, (user) => user.name.toLowerCase().indexOf(query.toLowerCase()) !== -1);
  }
  return stabilizedThis.map((el) => el[0]);
}
/**
 * Represents a book.
 * @constructor
 * @param {string} title - The title of the book.
 * @param {string} author - The author of the book.
 */
export default function RecoEnginePage() {
  const { LoginData } = useLoginSelector();

  // const userId = localJWTtoken.token.userId;
  const accessToken = LoginData?.jwt; // adjust if different name
  const role = 'DSA';

  const { search } = useLocation();
  const params = new URLSearchParams(search);

  const qrUrl = params.get('qrUrl');
  const userId = params.get('userId');

  useEffect(() => {
    const el = document.querySelector('.headerBox');
    if (el) console.log('elvalue', el);
    else console.log('el not found');
    if (el) el.style.display = 'none';
  }, []);
  return (
    <Page title="Klass Management System || Leads">
      <Container maxWidth="xl">
        <Box pt={3} pb={3} mb={4}>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            className="pageHeading"
          >
            <PageTitle info="Reco Engine" />
            <Box>
              <BrudCrumbs />
            </Box>
          </Stack>
          <Card>
            <Scrollbar>
              <div
                style={{
                  width: '100%',
                  height: '100vh',
                  background: '#fff',
                  // overflow: 'hidden',
                  borderRadius: '8px'
                }}
              >
                <iframe
                  // src="http://164.52.193.123/"
                  src={`${qrUrl}`}
                  title="Recommendation System"
                  style={{
                    position: 'relative',
                    // top: '-100px',
                    width: '100%',
                    height: '100vh',
                    border: 'none'
                    // overflow: 'hidden'
                  }}
                />
              </div>
            </Scrollbar>
          </Card>
        </Box>
      </Container>
    </Page>
  );
}
